/* ==========================================================================
   assets/om-chrome.js — behaviour for the Brand World 2026 chrome (wi-2026-1120)
   --------------------------------------------------------------------------
   Three overlays hang off the header (sections/header.liquid):
     - the Shop by Need mega menu (L60 v10, desktop 990+): a disclosure that lays
       over the page on a scrim; the rail shows ONE need panel at a time.
     - the phone drawer (L73 v1, below 990): a real dialog (focus trap, Escape,
       scrim click, page scroll lock, focus back to the hamburger).
     - the search pop-over (L74 v2): open/close + the typed state from Shopify's
       /search/suggest.json (no prices are printed).
   Only one is open at a time. Vanilla, idempotent (the theme editor re-renders
   the header section; every binding is delegated from `document` and guarded
   by a flag), no jQuery.
   ========================================================================== */
(function () {
  "use strict";
  if (window.__omChrome) return;
  window.__omChrome = true;

  var html = document.documentElement;
  var lastTrigger = null;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function focusables(root) {
    return $$('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])', root)
      .filter(function (el) { return el.offsetParent !== null; });
  }

  /* ---- header height, read by the overlays' max-height ------------------- */
  function setHeaderHeight() {
    var sec = $(".section-header");
    if (sec) html.style.setProperty("--header-height", Math.round(sec.getBoundingClientRect().bottom) + "px");
  }
  window.addEventListener("resize", setHeaderHeight);
  window.addEventListener("scroll", function () { if (isOpen("mega") || isOpen("search")) setHeaderHeight(); }, { passive: true });
  document.addEventListener("DOMContentLoaded", setHeaderHeight);
  setHeaderHeight();

  /* ---- which overlay is open --------------------------------------------- */
  function parts(kind) {
    if (kind === "mega") return { panel: $("[data-om-mega]"), scrim: $("[data-om-mega-scrim]"), trigger: $("[data-om-mega-toggle]") };
    if (kind === "drawer") return { panel: $("[data-om-drawer]"), scrim: $("[data-om-drawer-scrim]"), trigger: $("[data-om-drawer-open]") };
    return { panel: $("[data-om-search-panel]"), scrim: null, trigger: $("[data-om-search-toggle]") };
  }
  function isOpen(kind) { var p = parts(kind).panel; return !!(p && !p.hidden); }

  function open(kind, trigger) {
    ["mega", "drawer", "search"].forEach(function (k) { if (k !== kind) close(k, false); });
    var p = parts(kind);
    if (!p.panel) return;
    setHeaderHeight();
    p.panel.hidden = false;
    if (p.scrim) p.scrim.hidden = false;
    if (p.trigger) p.trigger.setAttribute("aria-expanded", "true");
    lastTrigger = trigger || p.trigger;
    if (kind === "drawer") {
      html.classList.add("om-scroll-lock");
      var c = $("[data-om-drawer-close]", p.panel); if (c) c.focus();
    } else if (kind === "search") {
      var i = $("[data-om-search-input]", p.panel); if (i) i.focus();
    } else if (kind === "mega") {
      var d = $(".mm-door.is-open", p.panel) || $(".mm-door", p.panel); if (d) d.focus({ preventScroll: true });
    }
  }
  function close(kind, restoreFocus) {
    var p = parts(kind);
    if (!p.panel || p.panel.hidden) return;
    p.panel.hidden = true;
    if (p.scrim) p.scrim.hidden = true;
    if (p.trigger) p.trigger.setAttribute("aria-expanded", "false");
    if (kind === "drawer") html.classList.remove("om-scroll-lock");
    if (restoreFocus !== false && lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
  }
  function openKind() { return ["drawer", "mega", "search"].filter(isOpen)[0] || null; }

  /* ---- the mega menu's rail: one need panel at a time -------------------- */
  function showDoor(key) {
    var mega = $("[data-om-mega]");
    if (!mega) return;
    $$(".mm-door", mega).forEach(function (d) {
      var on = d.getAttribute("data-om-door") === key;
      d.classList.toggle("is-open", on);
      /* is-open is the rail preview only; aria-current would announce "current page" on a door the shopper is not on (O3 a11y finding) */
      d.removeAttribute("aria-current");
    });
    $$("[data-om-panel]", mega).forEach(function (p) { p.hidden = p.getAttribute("data-om-panel") !== key; });
  }
  document.addEventListener("mouseover", function (e) {
    var d = e.target.closest && e.target.closest("[data-om-door]");
    if (d) showDoor(d.getAttribute("data-om-door"));
  });
  document.addEventListener("focusin", function (e) {
    var d = e.target.closest && e.target.closest("[data-om-door]");
    if (d) showDoor(d.getAttribute("data-om-door"));
  });

  /* ---- clicks ------------------------------------------------------------- */
  document.addEventListener("click", function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest("[data-om-mega-toggle]"))) { e.preventDefault(); isOpen("mega") ? close("mega") : open("mega", el); return; }
    if ((el = t.closest("[data-om-drawer-open]"))) { e.preventDefault(); open("drawer", el); return; }
    if ((el = t.closest("[data-om-search-toggle]"))) { e.preventDefault(); isOpen("search") ? close("search") : open("search", el); return; }
    if (t.closest("[data-om-mega-close]") || t.closest("[data-om-mega-scrim]")) { close("mega"); return; }
    if (t.closest("[data-om-drawer-close]") || t.closest("[data-om-drawer-scrim]")) { close("drawer"); return; }
    // outside click closes the search pop-over
    if (isOpen("search") && !t.closest("[data-om-search-panel]")) close("search", false);
    var chipEl = t.closest("[data-om-search-panel] a");
    if (chipEl) close("search", false);
  });

  /* ---- keys: Escape closes; Tab stays inside the drawer ------------------ */
  document.addEventListener("keydown", function (e) {
    var k = openKind();
    if (!k) return;
    if (e.key === "Escape") { e.preventDefault(); close(k); return; }
    if (e.key === "Tab" && k === "drawer") {
      var f = focusables(parts("drawer").panel);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  // crossing the 990 line closes the form that no longer exists at the new width
  var mq = window.matchMedia("(min-width: 990px)");
  var onMq = function () { close(mq.matches ? "drawer" : "mega", false); };
  if (mq.addEventListener) mq.addEventListener("change", onMq); else if (mq.addListener) mq.addListener(onMq);

  /* ---- search: the typed state ------------------------------------------- */
  var DOORS = [
    { re: /focus|memory|brain|lion|clarity|sharp/i, label: "Focus & Memory", url: "/collections/focus-memory" },
    { re: /calm|stress|sleep|relax|reishi|anxi/i, label: "Calm, Stress & Sleep", url: "/collections/calm-stress-sleep" },
    { re: /energy|endurance|perform|cordyceps|workout/i, label: "Performance & Energy", url: "/collections/energy-endurance" },
    { re: /immun|defen|turkey|chaga|protect/i, label: "Immunity & Protection", url: "/collections/immunity-defense" },
    { re: /daily|wellness|everyday|master|foundation/i, label: "Daily Wellness", url: "/collections/everyday-wellness" }
  ];
  function matchDoor(q) { for (var i = 0; i < DOORS.length; i++) if (DOORS[i].re.test(q)) return DOORS[i]; return null; }

  function renderResults(panel, q, data) {
    var mount = $("[data-om-search-results]", panel);
    var quiz = panel.getAttribute("data-quiz-url") || "/pages/quiz";
    var r = (data && data.resources && data.resources.results) || {};
    var products = (r.products || []).slice(0, 4);
    var articles = (r.articles || []).slice(0, 2);
    var door = matchDoor(q);
    if (!products.length && !articles.length && !door) {
      mount.innerHTML = '<p class="sr-empty om-small">No matches for &ldquo;' + esc(q) + '&rdquo;. Try <a href="' + esc(quiz) +
        '">Find your match</a> or <a href="/collections/all">Shop All</a>.</p>';
      return;
    }
    var h = "";
    if (products.length) {
      h += '<div class="sr-group"><p class="quick-label om-caps om-soft">Products</p>' + products.map(function (p) {
        var img = p.featured_image && p.featured_image.url
          ? '<img src="' + esc(p.featured_image.url) + '&width=88" alt="" width="44" height="44" loading="lazy">'
          : '<span class="sr-thumb" aria-hidden="true"></span>';
        var fmt = p.product_type ? '<span class="om-small om-soft--deep">' + esc(p.product_type) + "</span>" : "";
        return '<a class="sr-row" href="' + esc(p.url) + '">' + img + '<span class="sr-meta"><span class="om-subhead om-subhead--sm sr-name">' +
          esc(p.title) + "</span>" + fmt + "</span></a>";
      }).join("") + "</div>";
    }
    if (door) {
      h += '<div class="sr-group"><p class="quick-label om-caps om-soft">Shop by need</p><a class="sr-row" href="' + door.url +
        '"><span class="om-subhead om-subhead--sm sr-name">' + esc(door.label) + " &rarr;</span></a></div>";
    }
    if (articles.length) {
      h += '<div class="sr-group"><p class="quick-label om-caps om-soft">Articles</p>' + articles.map(function (a) {
        return '<a class="sr-row" href="' + esc(a.url) + '"><span class="sr-name">Blog post: ' + esc(a.title) + "</span></a>";
      }).join("") + "</div>";
    }
    h += '<p class="sr-foot om-small"><a href="/search?q=' + encodeURIComponent(q) + '">See all results for &ldquo;' + esc(q) + "&rdquo; &rarr;</a></p>";
    mount.innerHTML = h;
  }
  var timer = null, seq = 0;
  document.addEventListener("input", function (e) {
    var input = e.target.closest && e.target.closest("[data-om-search-input]");
    if (!input) return;
    var panel = input.closest("[data-om-search-panel]");
    var q = input.value.trim();
    var empty = $("[data-om-search-empty]", panel), mount = $("[data-om-search-results]", panel);
    clearTimeout(timer);
    if (!q) { empty.hidden = false; mount.innerHTML = ""; return; }
    timer = setTimeout(function () {
      var mine = ++seq;
      fetch("/search/suggest.json?q=" + encodeURIComponent(q) +
            "&resources[type]=product,article&resources[limit]=4&resources[options][unavailable_products]=last")
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (mine !== seq) return;
          empty.hidden = true;
          renderResults(panel, q, data);
        })
        .catch(function () { /* keep the last state on a transient error */ });
    }, 220);
  });
  document.addEventListener("submit", function (e) {
    var form = e.target.closest && e.target.closest("[data-om-search-form]");
    if (!form) return;
    var input = $("[data-om-search-input]", form);
    if (!input || !input.value.trim()) e.preventDefault();
  });

  /* ---- theme editor: a re-rendered header starts closed ------------------ */
  document.addEventListener("shopify:section:load", function () {
    html.classList.remove("om-scroll-lock");
    setHeaderHeight();
  });
})();
